import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {useStableRandom} from '@github-ui/use-stable-random'
import {ForYouItemSkeleton} from './shared/ForYouItemFallbacks'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import styles from './shared/ForYouSubSection.module.css'
import {useDecideNextAction} from './deciders/use-decide-next-action'

export function ForYouNextAction() {
  const recommendedAction = useDecideNextAction()

  // since we're re-using the For You implementation, we need to wrap the list of items in a <ul>
  // so that the <li> elements inside ForYouItem are valid for a11y.
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ul role="list" className={styles.list}>
      {recommendedAction}
    </ul>
  )
}

export function ForYouNextActionBoundary({children}: {children: React.ReactNode}) {
  return (
    <ErrorBoundary boundaryName="ForYouNextActionBoundary" fallback={null}>
      <Suspense fallback={<ForYouNextActionSkeleton />}>{children}</Suspense>
    </ErrorBoundary>
  )
}

export function ForYouNextActionSkeleton() {
  const phraseIndex = useStableRandom({min: 0, max: LOADING_PHRASES.length - 1})
  const phrase = LOADING_PHRASES[phraseIndex]

  return (
    <ul className={styles.list}>
      <ForYouItemSkeleton
        text={phrase}
        variant="embedded"
        action={<LoadingSkeleton variant="rounded" width="120px" height="28px" />}
      />
    </ul>
  )
}

const LOADING_PHRASES = [
  "Deserializing your pull request's destiny…",
  'git blame-ing the delay…',
  'Traversing the commit graph…',
  'Reticulating CI pipelines…',
  'Garbage collecting stale opinions…',
  'Checking if the dog ate your approvals…',
  "Waiting for Schrödinger's CI to collapse into a state…",
  'Begging the automerge daemon for a straight answer…',
  'Asking git log --oneline for the meaning of life…',
  'Checking out your fate on a detached HEAD…',
]
